import useApi from '../../../services/useApi'
import useFilters from '../../../hook/useFilters'
import moment from 'moment'
import {useState} from 'react'

const useGetProductWiseReport = () => {
  const [dateRange] = useState(() => JSON.parse(localStorage.getItem('selectedDateRange') || '{}'))

  const Api = useApi()

  const initialFilters = {
    page: 1,
    limit: 50,
    search: '',
    sort_by: 'total_profit/-1',
    start_date: dateRange?.startDate ?? moment().subtract(3, 'months').format('YYYY-MM-DD'),
    end_date: dateRange?.endDate ?? moment().format('YYYY-MM-DD'), // includes today,
    classification_filter: '',
    supplier_filter: '',
    products_filter: '',
  }

  const {filters, setMultipleFilters, onSearch, onSortingChange, onPageChange, onDateChange} =
    useFilters(initialFilters, {
      sortType: 'number',
    })

  const {data: response, isFetching} = Api.useGetQuery('/analytics/profitability/product-wise', {
    queryId: 'profitability-report',
    filters: filters,
    isToast: false,
    isErrorPageRedirection: false,
  })

  const onChangeClassificationFilter = (values: any[]) => {
    setMultipleFilters({
      classification_filter: values?.map((item: {value: string}) => item?.value).join(','),
      page: 1,
    })
  }

  const onChangeSupplierFilter = (values: any[]) => {
    setMultipleFilters({
      supplier_filter: values?.map((item: {value: string}) => item?.value).join(';'),
      page: 1,
    })
  }

  const onChangeProductFilter = (values: any[]) => {
    setMultipleFilters({
      products_filter: values?.map((item: {value: string}) => item?.value).join(','),
      page: 1,
    })
  }

  const onDownloadCSV = async () => {
    const {page, limit, ...restFilters} = filters
    const response: any = await Api.get('/analytics/profitability/product-wise/csv', {
      filters: restFilters,
    })
    return {
      message: response?.data?.message,
      status: response?.status,
    }
  }

  return {
    reportData: response?.data || [],
    isLoading: isFetching,
    onSearch,
    filters,
    onSortingChange,
    onPageChange,
    pagination: response?.meta?.pagination || {},
    onDateChangeCustomers: onDateChange,
    onChangeClassificationFilter,
    onChangeSupplierFilter,
    onChangeProductFilter,
    onDownloadCSV,
  }
}

export default useGetProductWiseReport
